//TODO: use information from the backend
export const vesselsTRACOS = ["MV34", "MV51"];

export const vesselsWithMopo = ["MLSS"];

export const vesselsAllowedForNewBarriersLayout = ["UARU"];

export const vesselsAllowedForFuzzyBowtieFeature = ["MV26"];

export const vesselsAllowedForDemoFuzzyBowtieFeature = ["MV13"];

export const isVesselAllowedForDemoFuzzyBowtie = (vesselId: string, isDemo: boolean) =>
  isDemo && vesselsAllowedForDemoFuzzyBowtieFeature.includes(vesselId);

export const isVesselAllowedForFuzzyBowtie = (vesselId: string, isDemo: boolean) =>
  vesselsAllowedForFuzzyBowtieFeature.includes(vesselId) ||
  isVesselAllowedForDemoFuzzyBowtie(vesselId, isDemo);

export const countriesNotAllowedForCtoMitigationProtocol = ["SENEGAL"];

export const countriesAllowedForSisModificationAssessment = ["BR"];

export const countriesAllowedForDemoSisModificationAssessment = ["SOUTH_AMERICA"];

export const isCountryAllowedForSisModificationAssessment = (country: string, isDemo: boolean) =>
  countriesAllowedForSisModificationAssessment.includes(country) ||
  (isDemo && countriesAllowedForDemoSisModificationAssessment.includes(country));

export const countriesAllowedForGroupingDecision = ["BR", "MEXICO"];
